// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "d56bc6bba88e50f4ee7328803ca7f539a6cca4e8/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};